<template>
  <div class="hull-date-picker">
    <div class="flex justify-start items-center gap-4">
      <div class="flat-pickr-wrapper relative">
        <feather-icon
          v-if="showClear"
          class="clear-icon"
          icon="XIcon"
          svgClasses="h-4 w-4"
          @click.stop="onClearButtonClick"
        />
        <feather-icon
          class="arrow-icon"
          svgClasses="h-4 w-4"
          icon="ChevronDownIcon"
        />
        <flat-pickr
          class="hull-date-flat-picker start-date"
          v-model="selectedDate"
          placeholder="事故日"
          :config.sync="configTimePicker"
          ref="selectedDatePicker"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { ColorMixin } from "@/mixins";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Japanese } from "flatpickr/dist/l10n/ja.js";
const FLAT_PICKR_CLASS_NAME = "flatpickr-calendar";
const HULL_DATE_FLAT_PICKR_CLASS_NAME = "hull-date-flat-picker";
const STYLE_OVERWRITE = "style-overwrite";

export default {
  name: "inputPeriodForm",
  props: {
    applyCallBack: { type: Function, required: true },
    clearable: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  mixins: [ColorMixin],
  components: {
    flatPickr,
  },
  data() {
    return {
      lastSelectedDate: null,
      selectedDate: null,
      configTimePicker: {
        enableTime: false,
        dateFormat: "Y-m-d",
        onClose: date => {
          if (date.length == 2) {
            this.selectedDate = date;
            this.applyCallBack(this.selectedDate);
          }
        },

        minDate: null,
        maxDate: null,
        locale: Japanese,
        mode: "range",
        monthSelectorType: "static",
      },
    };
  },
  computed: {
    showClear() {
      return this.clearable && this.selectedDate != null;
    },
  },

  methods: {
    onClearButtonClick() {
      this.selectedDate = null;
      this.applyCallBack(this.selectedDate);
    },
  },
  mounted() {
    // flatpickrに独自スタイルを当てるためにclass付与
    document.querySelectorAll(`.${FLAT_PICKR_CLASS_NAME}`).forEach(fc => {
      fc.classList.add(HULL_DATE_FLAT_PICKR_CLASS_NAME, STYLE_OVERWRITE);
    });
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
.hull-date-picker {
  .arrow-icon {
    position: absolute;
    right: 12px;
    top: 11px;
    pointer-events: none;
  }
  .clear-icon {
    position: absolute;
    right: 30px;
    top: 11px;
    cursor: pointer;
  }
  .flatpickr-input {
    padding-left: 12px;
  }
  .flat-pickr-wrapper {
    .calendar-icon {
      font-size: 15px;
      top: 50%;
      left: 16px;
      transform: translate(0%, -50%);
    }
    .flatpickr-input {
      border: solid 1px $aisea-light-gray;
      width: 240px;
    }
  }
  .flatpickr-input.active {
    border: 1px solid $aisea-blue !important;
  }
  .flatpickr-input {
    border: 1px solid white !important;
  }
}

.flatpickr-calendar {
  &.hull-date-flat-picker {
    .flatpickr-current-month {
      display: flex;
      justify-content: center;
      align-items: center;
      align-items: baseline;
      gap: 30px;

      span.cur-month {
        color: #626262;
      }
    }
    .flatpickr-day {
      &.selected,
      &.startRange,
      &.endRange,
      &.selected.inRange,
      &.startRange.inRange,
      &.endRange.inRange,
      &.selected:focus,
      &.startRange:focus,
      &.endRange:focus,
      &.selected:hover,
      &.startRange:hover,
      &.endRange:hover,
      &.selected.prevMonthDay,
      &.startRange.prevMonthDay,
      &.endRange.prevMonthDay,
      &.selected.nextMonthDay,
      &.startRange.nextMonthDay,
      &.endRange.nextMonthDay {
        background: $aisea-blue !important;
        -webkit-box-shadow: none;
        box-shadow: none;
        border-color: $aisea-blue !important;
      }
    }
  }
}
</style>
